<template lang="pug">
  #wrapper.l-base.l-wrapper(:class='wrapperClass')
    #wrapper-inner.l-wrapper-inner
      #content.l-content
        base-header
        slot
        base-footer
      base-aside
</template>

<script>
import BaseHeader from '@components/layouts/base/Header'
import BaseFooter from '@components/layouts/base/Footer'
import BaseAside from '@components/layouts/base/Aside'

export default {
  name: 'l-base',
  components: {
    BaseHeader,
    BaseFooter,
    BaseAside,
  },
  computed: {
    wrapperClass() {
      return this.$store.getters['ui/isAsideOpen'] ? 'l-aside-open' : 'l-aside-closed'
    },
  },
}
</script>

<style lang="scss">
@import '@assets/css/plugins/bootstrap/config';

.l-base {
  #wrapper-inner {
    padding-left: $wc-sidebar-width;
    transition: $wc-transition-all-cubic;
    transform-origin: center left;
    @include media-breakpoint-down(md) {
      padding-left: 0;
    }
  }
  @include media-breakpoint-up(lg) {
    &.l-aside-closed #wrapper-inner {
      padding-left: $wc-sidebar-min-width;
    }
  }
  .l-content {
    background-color: $wc-bg;
    padding-top: $wc-mainbar-height;
    @include media-breakpoint-down(md) {
      padding-top: $wc-mainbar-height-mobile;
    }
  }
  .l-section {
    > .l-section-h {
      padding-top: 1.5rem;
    }
    &:last-child > .l-section-h:last-child {
      padding-bottom: 1.5rem;
    }
  }
}
</style>
